import { Injectable } from '@angular/core';
import { AnalyticsService } from 'shared/src/services/analytics.service';

export enum LocalStorageKey {
  email = 'email',
  stripeCustomerId = 'stripeCustomerId',
  gender = 'gender',
  age = 'age',
  challenges = 'challenges',
  goal = 'goal',
  motivations = 'motivations',
  readerGoals = 'readerGoals',
  promotedBook = 'promotedBook',
  competitor = 'competitor',
  funnelVariant = 'funnelVariant',

  quizFlow = 'quizFlow',

  // Every quiz answer keyed by step, as sent to the server on sign-up
  webQuizAnswers = 'webQuizAnswers',
  // Funnels (PROJECT_NAME) that already reported their result-screen metric event
  resultMetricShown = 'resultMetricShown',

  book1 = 'book1',
  book2 = 'book2',
  book3 = 'book3',

  // For Axon pixel purchase tracking
  paymentValue = 'paymentValue',

  // NewsBreak advanced-matching demographics, already mapped to NewsBreak's own enums
  newsbreakDemographics = 'newsbreakDemographics',
}

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor(private analytics: AnalyticsService) {
    if (!this.checkStorageAvailability()) {
      this.analytics.track('web_local_storage_unavailable');
    }
  }

  set(key: LocalStorageKey, value: unknown): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error saving ${key} to localStorage`, error);
    }
  }

  get<T>(key: LocalStorageKey): T | undefined {
    const raw = localStorage.getItem(key);

    if (!raw) {
      return;
    }

    try {
      return JSON.parse(raw) as T;
    } catch (error) {
      console.error(`Error parsing localStorage item "${key}"`, error);
      return;
    }
  }

  remove(key: LocalStorageKey): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }

  private checkStorageAvailability(): boolean {
    try {
      const testKey = '__storage_test__';
      localStorage.setItem(testKey, testKey);
      const result = localStorage.getItem(testKey);
      localStorage.removeItem(testKey);
      return result === testKey;
    } catch (e) {
      return false;
    }
  }
}
